<div class="theme-static">
  <section class="header position-fixed w-100">
    <app-common-header></app-common-header>
  </section>

  <!-- End Header Part -->

  <!-- Start Page Header Title Part -->
  <section class="page-header-title">
    <div class="page-title-overlay"></div>
    <img
      src="assets/images/w2c/product-disclosure-statements-banner.png"
      alt=""
      class="w-100 page-title-image"
    />
    <div class="page-header-title-caption">
      <h1>Policy Documentation</h1>
      <!-- <p>World2Cover makes family travel insurance easy! Compare our levels of cover and select the best family travel insurance for you.</p> -->
    </div>
  </section>
  <!-- End Page Ttile  -->

  <!-- Main Content -->
  <main class="page-content py-5 pds-page">
    <div class="container">
      <div class="row g-0">
        <div class="col-lg-12">
          <h3 class="pds-heading fw-bold mb-3">
            Combined Product Disclosure Statement (PDS) and Financial Services Guide (FSG)
          </h3>
          <div class="page-content-info">
            <p>
              A Product Disclosure Statement (PDS) and Financial Services Guide (FSG)
              are important documents designed to help customers make an informed
              choice when purchasing World2Cover Travel Insurance. Please take the
              time to read this combined document before purchasing, as it contains
              information regarding:
            </p>

            <ul class="text-gray">
              <li>What the policy does or does not cover</li>
              <li>The terms, conditions, limitations, and exclusions of the policy</li>
              <li>The key features and benefits</li>
              <li>Your rights and obligations</li>
              <li>How the premium is calculated</li>
              <li>Information about the financial services provided</li>
              <li>
                Details about the provider, including how they are paid, and where
                to find information on how complaints are handled and resolved.
              </li>
            </ul>

            <p>
              If you are a past customer and require a copy of an older version of
              the PDS/FSG documents prior to 30 October 2017, please <a
              routerLink="/contact-us"
              [queryParams]="pdsService.getWhiteLabelQueryParams(partnerCode)"
              target="_blank"
              >contact us</a> to request a copy.
            </p>
          </div>
          <div class="card mb-3">
            <div class="card-body no-padding">
              <div class="row no-space">
                <h4 class="ps-4 p-3 mb-0">Current Version</h4>
                <div
                  class="row-inside spacemanagement"
                  *ngFor="let pds of differentDatesPDSGroup"
                >
                  <div
                    class="col-12 d-lg-flex d-block align-items-center"
                    *ngIf="pds.isActive"
                  >
                    <div class="col-lg-7 col-md-12 col-12">
                      <div class="p-3">
                        <p>
                          For any Policy Purchase <strong>ON</strong> or
                          <strong>AFTER</strong> the
                          {{ formatDate(pds.validFrom) }}, see Combined PDS
                          below:
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-lg-5 col-12 d-flex justify-content-between mb-3"
                    >
                      <div class="col-6">
                        <div class="pds-button">
                          <button class="btn-pds-new" (click)="viewPDSPDF(pds)">
                            <span
                              class="d-flex ps-2 pe-2 justify-content-between align-items-center adjustviewpds"
                            >
                              View<img
                                src="assets/icons/w2c/pds-view.png"
                                alt=""
                            /></span>
                          </button>
                        </div>
                      </div>

                      <div class="col-6">
                        <button class="btn-pds-new" (click)="downloadPDS(pds)">
                          <span
                            class="d-flex ps-2 pe-2 justify-content-between align-items-center adjustdowwnpds"
                            >Download
                            <img src="assets/icons/w2c/pds-download.png" alt=""
                          /></span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion no-radius" id="accordionPds">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button
                        class="accordion-button pds collapsed ps-4"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <h4>Previous Versions</h4>
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionPds"
                    >
                      <div class="accordion-body pds">
                        <div
                          class="row-inside"
                          *ngFor="let pds of differentDatesPDSGroup"
                        >
                          <div
                            class="card-body no-padding oldpds"
                            *ngIf="!pds.isActive"
                          >
                            <div class="row ps-4 pe-3 mt-3">
                              <div class="col-lg-7 col-md-12 col-12">
                                <div class="">
                                  <p>
                                    For any Policy Purchase
                                    <strong>ON</strong> or
                                    <strong>AFTER</strong> the
                                    {{ formatDate(pds.validFrom) }} and
                                    <strong>BEFORE</strong> the
                                    {{ formatDate(pds.validUntil) }}, see
                                    Combined PDS below:
                                  </p>
                                </div>
                              </div>

                              <div
                                class="col-lg-5 col-12 d-flex justify-content-between mb-3"
                              >
                                <div class="col-6">
                                  <div class="pds-button">
                                    <button
                                      class="btn-pds-new"
                                      (click)="viewPDSPDF(pds)"
                                    >
                                      <span
                                        class="d-flex ps-2 pe-2 justify-content-between align-items-center adjustviewpds"
                                      >
                                        View<img
                                          src="assets/icons/w2c/pds-view.png"
                                          alt=""
                                      /></span>
                                    </button>
                                  </div>
                                </div>

                                <div class="col-6">
                                  <button
                                    class="btn-pds-new"
                                    (click)="downloadPDS(pds)"
                                  >
                                    <span
                                      class="d-flex ps-2 pe-2 justify-content-between align-items-center adjustdowwnpds"
                                      >Download
                                      <img
                                        src="assets/icons/w2c/pds-download.png"
                                        alt=""
                                    /></span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                           class="row-inside"
                          *ngFor="let groupPDS of sameDatesPDSGroup"
                        >
                          <div class="card-body">
                            <div class="text-gray">
                              <p>
                                <strong>IF</strong> your Policy was purchased
                                <strong>AFTER</strong> the
                                {{ formatDate(groupPDS.validFrom) }} and
                                <strong>BEFORE</strong> the
                                {{ formatDate(groupPDS.validUntil) }} see the appropriate PDS
                                below:
                              </p>
                            </div>
                            <div class="row">
                              <div
                                class="col-lg-2 col-6 mb-3"
                                *ngFor="let pds of groupPDS.pds"
                              >
                                <div class="related-pds">
                                  <div class="d-flex justify-content-between">
                                    <button
                                      class="btn btn-pds-related w-50 me-1"
                                      (click)="viewPDSPDF(pds)"
                                    >
                                      <img src="assets/icons/w2c/visibility.png" alt="" />
                                    </button>
                                    <button
                                      class="btn btn-pds-related w-50"
                                      (click)="downloadPDS(pds)"
                                    >
                                      <img src="assets/icons/w2c/download.png" alt="" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Aside Part / Sidebar -->
      </div>

      <div class="row g-0 mt-5">
        <div class="col-lg-12">
          <h3 class="pds-heading fw-bold mb-3">
            Target Market Determinations (TMD)
          </h3>

          <div class="card mb-3">
            <div class="card-body no-padding">
              <div class="row no-space">
                <h4 class="ps-4 p-3 mb-0">Current Version</h4>
                <div
                  class="row-inside spacemanagement"
                  *ngFor="let tmd of currentTMDList"
                >
                  <div
                    class="col-12 d-lg-flex d-block align-items-center"
                  >
                    <div class="col-lg-7 col-md-12 col-12">
                      <div class="p-3">
                        <p>
                          For any Policy Purchase <strong>ON</strong> or
                          <strong>AFTER</strong> the
                          {{ formatDate(tmd.effectiveDate) }}, see TMD below:
                        </p>
                      </div>
                    </div>
                    <div
                      class="col-lg-5 col-12 d-flex justify-content-between mb-3"
                    >
                      <div class="col-6">
                        <div class="pds-button">
                          <button class="btn-pds-new" (click)="viewTMDPDF(tmd)">
                            <span
                              class="d-flex ps-2 pe-2 justify-content-between align-items-center adjustviewpds"
                            >
                              View<img
                                src="assets/icons/w2c/pds-view.png"
                                alt=""
                            /></span>
                          </button>
                        </div>
                      </div>

                      <div class="col-6">
                        <button class="btn-pds-new" (click)="downloadTMD(tmd)">
                          <span
                            class="d-flex ps-2 pe-2 justify-content-between align-items-center adjustdowwnpds"
                            >Download
                            <img src="assets/icons/w2c/pds-download.png" alt=""
                          /></span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion no-radius" id="accordionTmd">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTne">
                      <button
                        class="accordion-button pds collapsed ps-4"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTne"
                        aria-expanded="true"
                        aria-controls="collapseTne"
                      >
                        <h4>Previous Versions</h4>
                      </button>
                    </h2>
                    <div
                      id="collapseTne"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingTne"
                      data-bs-parent="#accordionTmd"
                    >
                      <div class="accordion-body pds">
                        <div
                          class="row-inside"
                          *ngFor="let tmd of previousTMDList"
                        >
                          <div
                            class="card-body no-padding oldpds"
                          >
                            <div class="row ps-4 pe-3 mt-3">
                              <div class="col-lg-7 col-md-12 col-12">
                                <div class="">
                                  <p>
                                    For any Policy Purchase
                                    <strong>ON</strong> or
                                    <strong>AFTER</strong> the
                                    {{ formatDate(tmd.effectiveDate) }} and
                                    <strong>BEFORE</strong> the
                                    {{ formatDate(tmd.validUntil) }},
                                    see TMD below:
                                  </p>
                                </div>
                              </div>

                              <div
                                class="col-lg-5 col-12 d-flex justify-content-between mb-3"
                              >
                                <div class="col-6">
                                  <div class="pds-button">
                                    <button
                                      class="btn-pds-new"
                                      (click)="viewTMDPDF(tmd)"
                                    >
                                      <span
                                        class="d-flex ps-2 pe-2 justify-content-between align-items-center adjustviewpds"
                                      >
                                        View<img
                                          src="assets/icons/w2c/pds-view.png"
                                          alt=""
                                      /></span>
                                    </button>
                                  </div>
                                </div>

                                <div class="col-6">
                                  <button
                                    class="btn-pds-new"
                                    (click)="downloadTMD(tmd)"
                                  >
                                    <span
                                      class="d-flex ps-2 pe-2 justify-content-between align-items-center adjustdowwnpds"
                                      >Download
                                      <img
                                        src="assets/icons/w2c/pds-download.png"
                                        alt=""
                                    /></span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <app-footer></app-footer>
</div>
